module.exports = __webpack_public_path__ + "img/code.578ef68c.png";